import { useEffect, useState } from 'react'

import css from './sass/adminitem.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import { canEditAuction } from './permissionsutil'

import grayDelete from './images/trash-icon-gray.svg'
import grayEdit from './images/edit-icon-gray.svg'
import blueEdit from './images/edit-icon-blue.svg'

import ItemDeleteButton from './ItemDeleteButton'
import { getImageUrl } from '../util/images'
import ItemBidHistoryTable from './UserDetail/ItemBidHistoryTable'
import UserFullHistoryTable from './UserDetail/UserFullHistoryTable'

import { formatMoney } from 'services/util'
import ItemLinkCopyButton from './ItemLinkCopyButton'


export default function ItemDisplayRow({ item, auction, liveStatus, updateEditItemId, showEditItemModal, refreshAdminAuctionQuery, hasEnded, isUserSR }) {

  const [imageUrl, setImageUrl] = useState()

  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auction?.AuctionCode, item?.ItemCode, item?.ImageFilename)
    setImageUrl(url)
  }, [auction, item])

  const fullName = ( bidderInfo ) => {
    if (!bidderInfo.FirstName || !bidderInfo.LastName) return 'N/A'
    return `${bidderInfo.FirstName} ${bidderInfo.LastName}`
  }

  const paidStatus = (itemDetail) => {
    if (liveStatus === 'ended') {
      if (itemDetail?.Paid) return 'Yes'
      else {
        if (item.BidCount === 0) return 'N/A'
        else return 'No'
      }
    }
    else return 'N/A'
  }

  //formatting for user bid history table
  const user = {
    UserId: item?.CurrentHighBidder,
    FullName: item?.BidderFullName,
  }

  if (isUserSR) {
    return (
    <>
      <tr className={css['admin-item-row']}>
        <td>
          <img src={imageUrl} alt={item?.Title}/>
        </td>
        <td>{item?.Title}</td>
        <td>{item?.Description}</td>
        <td>${formatMoney(item?.Value)}</td>
        <td>${formatMoney(item?.StartingBid)}</td>
        <td>${formatMoney(item?.MinRaise)}</td>
      </tr>
    </>
  )
  }

  return (
    <>
      <tr className={css['admin-item-row']}>
        <td>
          {(hasEnded || !canEditAuction(auction) || isUserSR)
          ? <div className={css['admin-item-row-actions-ended']}>
              <img className={css['admin-item-action-icons']} src={grayDelete} alt={'Item Delete Icon - action not available'}/>
              <img className={css['admin-item-action-icons']} src={grayEdit} alt={'Item Edit Icon - action not available'}/>
              <ItemLinkCopyButton item={item} auction={auction} />
            </div>
          : <div className={css['admin-item-row-actions']}>
              <ItemDeleteButton item={item} refreshAdminAuctionQuery={refreshAdminAuctionQuery} style={'text'} />
              <button className={`${css['admin-item-edit-button']}`} onClick={()=>updateEditItemId(item.ItemId)}>
                <img className={css['admin-item-action-icons']} src={blueEdit} alt={'Item Edit Icon'}/>
              </button>
              <ItemLinkCopyButton item={item} auction={auction} />
            </div>}
        </td>

        <td>
          <img src={imageUrl} alt={item?.Title}/>
        </td>

        <td>{item?.Title}</td>
        <td>{item?.Category ? item.Category : 'N/A'}</td>
        <td>{item.BidCount > 0 ? (<ItemBidHistoryTable auctionDetail={auction} item={item} />) : '0'}</td>
        <td className={item.CurrentBid > item.Value ? themeCss['boldGreen'] : ''}>${formatMoney(item.CurrentBid)}</td>
        <td>{user.FullName !== 'N/A' ? <UserFullHistoryTable auctionDetail={auction} user={user} /> : 'N/A'}</td>
        <td>${formatMoney(item?.Value)}</td>
        <td>${formatMoney(item?.StartingBid)}</td>
        <td>${formatMoney(item?.MinRaise)}</td>
        <td>{paidStatus(item)}</td>
      </tr>
    </>
  )
}